<template>
	<div class="page">

		<scroll-to :links="scrollTo"></scroll-to>


		<div class="page-content-wrap">
			

			<div class="content-place">

				<div class="row">
					<errors></errors>
				</div>


				<div class="row">
					<h3 id="s1" class="title-steps">Снимки</h3>
					<div class="col-lg-12 section-work">
						<sortableImages @exportImages="exportImages"  :images="www.images"></sortableImages>
					</div>
				</div>

				<div class="row">
					<h3 id="s2" class="title-steps">Мета дани</h3>
					<div class="col-lg-12 section-work">
						<forms v-if="this.openForms" @exportMeta="exportMeta" :formElements="formElements"></forms>
					</div>
				</div>

				<div class="row" v-if="www.type == 'video'">
					<h3 id="s3" class="title-steps">Видео</h3>
					<div class="col-lg-12 section-work">
						<forms v-if="this.openForms" @exportMeta="exportVideoLink" :formElements="videoForm"></forms>
					</div>
				</div>

				<div class="row" v-if="www.type == 'pdf'">
					<h3 id="s3" class="title-steps">PDF</h3>
					<div class="col-lg-12 section-work">
						<p>Избран файл: <a target="_blank" :href="www.link">{{ www.link }}</a></p>
						<files-block></files-block>


						<forms v-if="this.openForms" ></forms>
					</div>
				</div>

				<div class="row">
					<h3 id="brand" class="title-steps">Производител</h3>
					<div class="col-lg-12 section-work">
						<form-list :limit="1" :filters="www.brand" :where="'shop/brand/search'" @exportList="exportBrands"></form-list>
					</div>
				</div>

			</div>


		</div>

		<bottom-menu :www="www"></bottom-menu>
		<modal-create-folder v-if="modalCreateFolder"></modal-create-folder>

	</div>
</template>
<script>

	import ModalCreateFolder from "../../app_modules/ModalCreateFolder";


	import ScrollTo from '../../layouts/ScrollTo'
	import Errors from '../../app_modules/Errors'
	import BottomMenu from '../../app_modules/BottomMenu'

	import SortableImages from '../../app_modules/SortableImages'
	import SortableCategory from '../../app_modules/SortableCategory'
	import FilesBlock from '../../app_modules/FilesBlock'

	import SortableProducts from '../../app_modules/SortableProducts.vue'

	import FormList from '../../../components/app_modules/FormList'

	import Forms from '../../app_modules/Forms'
	import Editor from '../../app_modules/Editor'

	import axios from 'axios'

	export default {
		name: 'edit-pdf',


		data() {
			return {
				productPage: true,
				modalCreateFolder: false,
				openForms:false,
				domain: this.$store.getters.getDomainName,
				www: {
					link_send: this.$store.getters.getDomainName+'system/files/create',
					method: 'post',
					redirect: 'system-files',
					brand: [],
					title: '',
					link: '',
					type: false,
					link: '',
					status: true,

					images: [],
					description: ``,

				},
				formElements: [
				{
					id: 0,
					type: 'input',
					name: 'Title',
					placeholder: 'title for product H1',
					model: '',
					readonly: true
				},

				{
					id: 1,
					type: 'textarea',
					name: 'description',
					placeholder: 'Description',
					model: '',
					readonly: true
				},
				{
					id: 3,
					type: 'status',
					model: true,
					readonly: true
				}


				],

				videoForm: [
				{
					id: 0,
					type: 'input',
					name: 'video link',
					placeholder: 'video from youtube',
					model: '',
					readonly: true
				},
				],

				scrollTo: [
				{
					id: 1,
					name: ' Лого',
					href: '#s1',
				},
				{
					id: 2,
					name: 'Мета дани',
					href: '#s2',
				},
				{
					id: 3,
					name: 'Описание',
					href: '#s3',
				},
				{
					id: 3,
					name: 'Производител',
					href: '#s4',
				},

				]
			}
		},
		methods: {


			exportContent(data) {
				this.www.description = data

			},
			exportLinkFilePdf(data) {
				this.www.link = this.$store.getters.getCloudDomain1 + 'files/' + data 


			},

			exportMeta(data) {

				this.www.title = data[0].model
				this.www.description = data[1].model
				this.www.status = data[2].model

				this.www.status ? this.www.status = 1 : this.www.status = 0

			},
			exportVideoLink(data) {
				this.www.link = data[0].model
			},
			// exportCategoryId(data) {
			// 	this.www.subcategory_id = data
			// },
			exportImages(data) {
				console.log(data)
				console.log(data)
				console.log(data)
				console.log(data)
				this.www.images = data
			},
			exportBrands(data) {
				this.www.brand = data
			},
			
		},
		created() {
			eventBus.$on('closeModalCreateFolder', data => {this.modalCreateFolder = data})
			eventBus.$on('exportLinkFile', this.exportLinkFilePdf)


			
			if(this.$route.name == 'system-files-create-video') {
				this.www.type = 'video'
			} else if(this.$route.name == 'system-files-create-pdf') {
				this.www.type = 'pdf'
			}



			//if(this.$route.name == 'shop-brands-edit') {
				if(this.$route.name == 'system-files-edit-video' || this.$route.name == 'system-files-edit-pdf') {

					axios.get(this.domain+ 'files/pdf/edit/'+this.$route.params.id)

					.then(response => {
						this.www.title = response.data['title']
						this.www.description = response.data['description']
						this.www.link = response.data['link']
						this.www.type = response.data['type']
						this.www.link = response.data['link']
						this.www.status = response.data['status']
						this.www.brand = response.data['brand']

					// send active category

					var images =  response.data['images'].split(";")
					images = images.reverse()

					for (var i = images.length - 1; i >= 0; i--) {
						this.www.images.push({ 
							icon: images[i],
							id: i,
						})

					}

					this.formElements[0].model = response.data['title']
					this.formElements[1].model = response.data['description']
					this.formElements[2].model = response.data['status']
					this.videoForm[0].model = response.data['link']


					this.www.link_send = this.domain+'system/files/update/'+this.$route.params.id
					this.www.method = 'patch'


					eventBus.$emit('sendLinkAndMethod', this.www)

					this.openForms = true
					return


				})
					.catch(error => {
					// if(error.response.status == 404) {
					// 	this.$router.push({ name: '404' })
					// }
				})


				} else {
					this.openForms = true
				}



			},
			beforeDestroy() {
				eventBus.$off('closeModalCreateFolder')
				eventBus.$off('exportLinkFile', this.exportLinkFilePdf)

			},
			components: {
				ModalCreateFolder,
				Forms,
				ScrollTo,
				Editor,
				FormList,
			//SortableCategory,
			Errors,
			BottomMenu,
			SortableImages,
			SortableCategory,
			SortableProducts,
			FilesBlock,
		},

	}
</script>

<style scoped src="../../../assets/css/page-data.css"></style>
<style scoped>
h5 {
	font-size: 11px;
}
h5 {
	display: block;
	font-size: 11px;
	color: rgb(193, 193, 193);
	color: #006886;
	font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/system/files/data.vue